class MenuDrawerModal {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // モーダル開くトリガー - より高い優先度でキャプチャフェーズで処理
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-modal-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const modalId = trigger.getAttribute('data-modal-trigger');
        this.openModal(modalId);
      }
    }, true); // キャプチャフェーズで実行

    // モーダル閉じるトリガー
    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('[data-modal-close]');
      if (closeBtn) {
        e.preventDefault();
        this.closeModal();
      }
    });

    // ESCキーでモーダルを閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeModal();
      }
    });
  }

  openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      
      // ドロワーが開いている状態を保持
      const drawer = document.querySelector('#Details-menu-drawer-container');
      if (drawer && drawer.hasAttribute('open')) {
        drawer.setAttribute('data-modal-open', 'true');
      }
      
      // フォーカスをモーダルに移動（少し遅延）
      setTimeout(() => {
        const firstFocusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) {
          firstFocusable.focus();
        }
      }, 100);
    }
  }

  closeModal() {
    const activeModal = document.querySelector('.menu-drawer__modal.is-active');
    if (activeModal) {
      activeModal.classList.remove('is-active');
      activeModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      
      // ドロワーの状態をリセット
      const drawer = document.querySelector('#Details-menu-drawer-container');
      if (drawer) {
        drawer.removeAttribute('data-modal-open');
      }
    }
  }
}

// DOMContentLoadedで初期化
document.addEventListener('DOMContentLoaded', () => {
  new MenuDrawerModal();
});